import { computed } from 'vue';
import { defineStore, storeToRefs } from 'pinia';
import Functionality from '@/objects/generated/functionality';
import { useEventCommonStoreRef } from '.';
import type { FunctionalityType } from '@/objects/generated';

export const useAccessStore = defineStore('access', () => {
    const { Event } = useEventCommonStoreRef();
    const hiddenFields = computed(() => {
        const f = new Map<string, string[]>();
        const Eventfunctionality = Event.value?.Functionalities;
        if (!Eventfunctionality) {
            return f;
        }
        for (const [Classname, fieldList] of Functionality) {
            for (const [FieldName, functionalities] of fieldList) {
                for (const func of functionalities) {
                    if (!Eventfunctionality!.includes(func)) {
                        if (!f.has(Classname)) {
                            f.set(Classname, []);
                        }
                        f.get(Classname)!.push(FieldName);
                    }
                }
            }
        }
        console.log('Hidden fields', f);
        return f;
    });

    const isHidden = (classname: string, fieldname: string) => {
        const hidden = hiddenFields.value.get(classname);
        if (!hidden) {
            return false;
        }
        return hidden.includes(fieldname);
    };

    const hasFunctionality = (functionality: FunctionalityType) => {
        const Eventfunctionality = Event.value?.Functionalities;
        if (!Eventfunctionality) {
            return false;
        }
        return Eventfunctionality.includes(functionality);
    };

    return { HiddenFields: hiddenFields, IsHidden: isHidden, HasFunctionality: hasFunctionality };
});

/**
 * Return a reactive reference to the user store.
 * @returns
 */
export const useAccessStoreRef = () => storeToRefs(useAccessStore());
